export const usePluginPullProduct = () => {
    const extensions = () => {
        return {
            canPullProduct() {
                if (! this.permission.has('write')) {
                    this.logger.error('没有刷新权限')
                    return false
                }

                const bn = this.BizNode[this.componentType ?? this.productType]

                if ('function' !== typeof bn.pull) {
                    this.logger.error('不支持刷新')
                    return false
                }

                return true
            },

            async cmdPullProduct() {
                await this.runAction(
                    () => this.execute(
                        async () => {
                            await this.pullProduct()
                            this.selectNodes([this.root])
                        }
                    ),

                    {action: '刷新模型制品'},
                )

            },

            async pullProduct() {
                const bn = this.BizNode[this.componentType ?? this.productType]
                await bn.pull(this, this.root)
                this.logger.info('刷新成功')
            },

            useCanPullProduct() {
                this.usePermission()
                return this.canPullProduct()
            },
        }
    }

    return {extensions}
}
